import React from 'react';
import { services } from './services';

const SeeAllButton = () => {


  return (
    <>
    {/* // <div className="container batch pb-5"> */}
      <h1 className="text-white btc">Batches</h1>
      <div id="services-carousel" className="owl-carousel owl-theme p-2">
        <div id="service-card-template" className="">

        <div id="services-container" className="card-group mx-5 ">
        
          {services.map((service, index) => (
<div className="col-4">
            <div key={index} className="card cardhvr cardproject">
            <img
              src={service.image}
              className="card-img-top img-thumbnail shadow"
              style={{
                borderTopLeftRadius: "20px",
                borderTopRightRadius: "20px",
                maxHeight: "150px",
              }}
              alt="..."
            />
            <div className="card-body">
              <h5 className="text-light">Information</h5>
              <div className="cdiv p-3 rounded">
                <div className="row">
                  <div className="col-9">
                    <p className="card-text">Selected Students:</p>
                  </div>
                  <div className="col-3">
                    <p className="card-text">{service.students}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-9">
                    <p className="card-text">Total projects:</p>
                  </div>
                  <div className="col-3">
                    <p className="card-text">{service.projectNo}</p>
                  </div>
                </div>
                <p className="card-text">
                  <br />
                  <b>Projects :</b>
                  <br />
                </p>
                <ul className="text-lg-start pro">
                  <li>
                    <a href="/">{service.pro1}</a>
                  </li>
                  <li>
                    <a href="/">{service.pro2}</a>
                  </li>
                  <li>
                    <a href="/">{service.pro3}</a>
                  </li>
                </ul>
              </div>
              <div>
                <a href="batchDetails" className="btn btn-primary btnpurple">
                  <span></span>Batch Detail
                </a>
              </div>
            </div>
          </div> </div>
          ))}
          </div>
       
      </div></div>
    {/* </div> */}
    </>
  );
};

export default SeeAllButton;
